/**
 * Copyright(c) 2022 Fenix Outdoor International AG.
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Fenix ("Confidential
 * Information"). You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the contract agreement you entered into with Fenix.
 *
 */
const constants = {
  DATE_FORMAT: "DD/MM/YYYY",
  CUSTOMER_ACCOUNT_STATUS: {
    NONE: "none",
    PARTIAL: "partial",
    COMPLETE: "complete",
  },
  AVAILABLE_COMPANIES: {
    51: "Fjällräven Germany",
    31: "Fjällräven Netherlands",
    46: "Fjällräven Sweden",
    HAS: "Hanwag Germany",
    13: "Fjällräven Denmark",
    44: "Fenix Outdoor UK",
  },
  USER_PREFERENCES: {
    CUSTOMERS_TABLE_LIMIT: "CUSTOMERS_TABLE_LIMIT",
    SEASONS_TABLE_LIMIT: "SEASONS_TABLE_LIMIT",
  },
};

export default constants;
